var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"m-r-10i",attrs:{"icon":"el-icon-arrow-left","circle":""},on:{"click":function($event){return _vm.backOrTo(_vm.backPath)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }